import { isArray, isObject, camelCase } from 'lodash';

const camelize = (object) => {
  if (isArray(object)) {
    return object.map(camelize);
  }

  if (isObject(object)) {
    return Object.keys(object).reduce((current, nextProp) => {
      current[camelCase(nextProp)] = camelize(object[nextProp]); // eslint-disable-line
      return current;
    }, {});
  }

  return object;
};

export default camelize;



/** WEBPACK FOOTER **
 ** ./apps/storePages/cartDropdown/lib/camelize.js
 **/